module.exports = "#team-due {\n  position: relative;\n  height: auto;\n  width: auto;\n  top: 0px; }\n\n.team-list-preview ul li {\n  width: 32%; }\n\n.mrgn-40 {\n  margin-left: 40px; }\n\n.mrgn-40 input {\n    width: 360px;\n    border-radius: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/teams-list/teams-list.component.scss
// module id = ./src/app/teams-list/teams-list.component.scss
// module chunks = main